module.exports = __webpack_public_path__ + "img/arrow.e7e06de9.svg";